import styles from "./KnowledgeBaseTab.module.css";

export interface BtnVariant {
  title: string;
  bntActive: boolean;
}

export type KnowledgeBaseTabProp = {
  btnList: BtnVariant[];
  callBack: (arg: any) => void;
  getViewArea: (arg: string) => void;
};

function KnowledgeBaseTab(props: KnowledgeBaseTabProp): JSX.Element {
  const { btnList, callBack, getViewArea } = props;

  return (
    <div className={styles.frame}>
      {btnList.map((btn, index) => (
        <div
          className={`${styles.Bnt} ${
            btn.bntActive
              ? " border border-[#4856DD] text-[#4856DD] bg-[#EDEEFC] font-medium "
              : "border border-[#E5E7EB] text-[#1F2A37] bg-[#E5E7EB] font-normal"
          }`}
          onClick={() => {
            getViewArea(btn.title);
            callBack(index);
          }}
          id={`knowledgeTab${index}`}
          tabIndex={0}
          onKeyDown={() => {}}
          role="button"
        >
          {btn.title}
        </div>
      ))}
    </div>
  );
}

export default KnowledgeBaseTab;
